// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.riskCriteriaTable th[data-v-36c9ebc4],\n.riskCriteriaTable td[data-v-36c9ebc4] {\n  border: 1px solid #c9c8c8;\n  padding: 8px 12px;\n  font-size: 0.9em;\n  text-align: center;\n  vertical-align: middle;\n}\n.riskCriteriaTable thead th[data-v-36c9ebc4] {\n  background-color: #f5f5f5;\n  font-weight: 700;\n}\n.riskCriteriaTable .riskCriteriaCell[data-v-36c9ebc4] {\n  text-align: left;\n  line-height: 1.6;\n}\n", ""]);
// Exports
module.exports = exports;
